var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.hasPermission)?[(!_vm.hideUnauthorisedMessage)?_vm._t("unauthorised",function(){return [_c('UnauthorisedState',{attrs:{"data-test":"no-permission"}})]}):_vm._e()]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }